import { render, staticRenderFns } from "./SidebarNav.vue?vue&type=template&id=2a249380&scoped=true&shadow"
import script from "./SidebarNav.vue?vue&type=script&lang=js&shadow"
export * from "./SidebarNav.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SidebarNav.vue?vue&type=style&index=0&id=2a249380&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2a249380",
  null
  ,true
)

export default component.exports